import { useMemo } from "react";

import { useLocation } from "react-router-dom";

import { useUser } from "@components/user-context";
import { prettyLogEvent } from "@internal/analytics";
import { type User } from "@internal/user";
import { type LogEventParams } from "@north-beam/nb-client-side/analytics";
import { usePage } from "@north-beam/nb-client-side/hooks";

export type PrettyLogEventPageArg = Omit<
  Parameters<typeof prettyLogEvent>[0],
  "page"
>;

export const usePrettyLogEventPage = () => {
  const location = useLocation();
  const { user } = useUser();
  const page = usePage({ pathname: location.pathname });

  return useMemo(() => {
    if (page) {
      return (params: Omit<LogEventParams<User>, "page" | "user">) =>
        prettyLogEvent({
          ...params,
          page: page.value,
          user,
        });
    }
    return () => null;
  }, [page, user]);
};
